import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-date-picker.css';

var getClassNameList = classNames.bind(styles);
var DayName;
(function (DayName) {
    DayName[DayName["SUN"] = 0] = "SUN";
    DayName[DayName["MON"] = 1] = "MON";
    DayName[DayName["TUE"] = 2] = "TUE";
    DayName[DayName["WED"] = 3] = "WED";
    DayName[DayName["THU"] = 4] = "THU";
    DayName[DayName["FRI"] = 5] = "FRI";
    DayName[DayName["SAT"] = 6] = "SAT";
})(DayName || (DayName = {}));
var UitkDay = function (props) {
    var disabled = props.disabled, date = props.date, selection = props.selection, selectionStart = props.selectionStart, selectionEnd = props.selectionEnd, content = props.content, onSelectDate = props.onSelectDate, formattedDate = props.formattedDate, formattedFriendlyDate = props.formattedFriendlyDate, holidayName = props.holidayName;
    var l10n = useLocalization();
    var dayContent;
    var dayAriaLabel;
    var dayContentClass;
    var a11yText;
    // Type guard to support both objects and strings as content.
    var isContentObject = function (arg) {
        return typeof arg === 'object' && arg !== null;
    };
    if (isContentObject(content)) {
        dayContent = content.text;
        dayAriaLabel = content.ariaLabel;
        dayContentClass = content.className;
    }
    else {
        dayContent = content;
    }
    var onClickAction = function (e) {
        onSelectDate(e, date);
    };
    if (disabled) {
        a11yText = l10n && l10n.formatText('datePicker.dateDisabled.a11yLabel', formattedFriendlyDate || '');
    }
    else if (selectionStart && selectionStart.getTime() === date.getTime()) {
        a11yText = l10n && l10n.formatText('datePicker.checkInDate.a11yLabel', formattedFriendlyDate || '');
    }
    else if (selectionEnd && selectionEnd.getTime() === date.getTime()) {
        a11yText = l10n && l10n.formatText('datePicker.checkOutDate.a11yLabel', formattedFriendlyDate || '');
    }
    else {
        a11yText = "".concat(formattedFriendlyDate);
    }
    var a11yDateLabelArr = [a11yText];
    if (holidayName) {
        a11yDateLabelArr.push(holidayName);
    }
    if (dayContent) {
        a11yDateLabelArr.push(dayContent);
    }
    if (dayAriaLabel) {
        a11yDateLabelArr.push(dayAriaLabel);
    }
    var a11yDateLabel = a11yDateLabelArr.join('. ');
    var dayBtnClassNames = getClassNameList('uitk-date-picker-day', dayContentClass, { 'is-disabled': disabled }, { selected: selection && selection.isDateSelected(date) }, {
        edge: (selectionStart && selectionStart.getTime() === date.getTime()) ||
            (selectionEnd && selectionEnd.getTime() === date.getTime())
    });
    return (React.createElement("button", { type: "button", className: dayBtnClassNames, onClick: onClickAction, "data-day": formattedDate, "data-day-content": dayContent, "aria-label": a11yDateLabel, disabled: disabled }, !!holidayName && React.createElement("span", { className: getClassNameList('uitk-date-picker-day-holiday') })));
};
var UitkNewDay = UitkDay;

export { DayName, UitkDay, UitkNewDay };
